import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="copy-button"
export default class extends Controller {
  static targets = ["feedback", "button"]

  copy(event) {
    event.preventDefault();
    const link = event.currentTarget.dataset.link;

    navigator.clipboard.writeText(link).then(() => {
      if (this.hasButtonTarget) {
        this.updateButtonStyle();
      }

      if (this.hasFeedbackTarget) {
        this.showFeedback();
      }
    }).catch((error) => {
      console.error("Error copying text: ", error);
    });
  }

  updateButtonStyle() {
    this.buttonTarget.classList.remove("btn-outline-muted");
    this.buttonTarget.classList.add("btn-outline-success");

    const successText = this.buttonTarget.dataset.successText;
    if (successText) {
      this.buttonTarget.innerHTML = `<i class="fa-solid fa-check me-1"></i> <small>${successText}</small>`;
    }
  }

  showFeedback() {
    this.feedbackTarget.classList.remove("d-none");
    setTimeout(() => {
      this.feedbackTarget.classList.add("d-none");
    }, 2000);
  }
}
